/**
 * Numbers in the settings rows Delphi's *Configurare* writes. Delphi stores them with the
 * workstation's decimal separator, the Romanian comma (`comision` = `0,5`, `comision_25000` =
 * `0,081`), and parses them back with that separator, so the Configuration page reads either
 * separator and writes Delphi's comma (every setting follows Delphi, bridge day check 2026-10-27
 * H-2). The backend reads them the same way (`getLargeContractSettings`, Ask AI shop rules).
 */

/** A stored value (`0,5` or `0.5`) as a number; `fallback` when it is missing or unreadable. */
export const parseDelphiSettingNumber = (value: string | undefined, fallback: number): number => {
    if (value === undefined || value.trim() === '') {
        return fallback;
    }
    const parsed = Number(value.trim().replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : fallback;
};

/** A form value as Delphi stores it: `0.5` → `0,5`; `fallback` when the field is empty. */
export const toDelphiSettingNumber = (value: unknown, fallback: number): string => {
    if (typeof value === 'number' && Number.isFinite(value)) {
        return String(value).replace('.', ',');
    }
    const text = typeof value === 'string' ? value : undefined;
    return String(parseDelphiSettingNumber(text, fallback)).replace('.', ',');
};
